import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment';
import { NovedadesMes } from '../../../../models/novedadesMes';
import { NovedadesMesService } from '../../../../services/novedades-mes.service';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-novedades-mes-list',
  templateUrl: './novedades-mes-list.component.html',
  styleUrls: ['./novedades-mes-list.component.css']
})
export class NovedadesMesListComponent implements OnInit
{

  @Input() personalId: number;
  @Input() novedadesMes: NovedadesMes[];
  @Input() permisoEdicion: boolean = true;
  @Output() VisualizarDetalle = new EventEmitter<NovedadesMes>();

    
  novedadesMesOri: NovedadesMes[];
  novedadesMesGrupo: NovedadesMes[];
  filtroDesde: string;
  filtroHasta: string;
  agrupar: boolean = false;

  constructor(private novedadesMesService: NovedadesMesService,
              private momentService: MomentSetService) { }

  ngOnInit(): void
  {
    this.novedadesMesOri = this.novedadesMes;
    this.inicializaFiltros();
    
    this.filtrarNovedades();
  }

  inicializaFiltros()
  {
    let fechaHoy = new Date();
    let fechaIni = new Date();
    fechaIni.setDate(fechaIni.getDate() - 30);

    let mesString = ('0' + (fechaIni.getMonth() + 1).toString()).slice(-2); //agrega cero por si es menor de 10
    let diaString = ('0' + (fechaIni.getDate()).toString()).slice(-2); //agrega cero por si es menor de 10
    this.filtroDesde = (fechaIni.getFullYear()).toString() + "-" + mesString + "-" + diaString ;

    mesString = ('0' + (fechaHoy.getMonth() + 1).toString()).slice(-2); //agrega cero por si es menor de 10
    diaString = ('0' + (fechaHoy.getDate()).toString()).slice(-2); //agrega cero por si es menor de 10
    this.filtroHasta = (fechaHoy.getFullYear()).toString() + "-" + mesString + "-" + diaString ;
  }

  filtrarNovedades()
  {
    let desde = moment(this.filtroDesde, "YYYY/MM/DD").toDate();
    let hasta = moment(this.filtroHasta, "YYYY/MM/DD").toDate();
    
    this.novedadesMes = this.novedadesMesOri.filter(i => Date.parse(i.fecha) <= hasta.getTime() && Date.parse(i.fecha) >= desde.getTime());    
  }

  onChangeAgrupamiento()
  {
    //Cambia lista
    if (this.agrupar == true)
    {
      if (this.novedadesMesGrupo == undefined)
      {
        this.novedadesMesService.getByPersonal(this.personalId, true).subscribe(
          data =>
          {
            data.forEach((currentValue,index,arr) => {
              currentValue.fecha = this.momentService.convertDateServer(currentValue.fecha);
            });
            
            this.novedadesMesGrupo = data;
            this.novedadesMes = this.novedadesMesGrupo;
          });

      } else
      {
        this.novedadesMes = this.novedadesMesGrupo;
      }
      
    } else
    {
      this.filtrarNovedades();
    }
  }

  onChangeFiltros()
  {
    this.filtrarNovedades();
  }

  visualizarDetalle(novedadPeriodo)
  {
    this.VisualizarDetalle.emit(novedadPeriodo);
  }

  add()
  {
    let novedadMes: NovedadesMes = { id: 0, personal: this.personalId, cantidad: 0, importe: 0, moneda: 1, quincena: "", motivo: "", fecha: new Date().toString(), unidadMedida: "" };
    this.VisualizarDetalle.emit(novedadMes);
  }
}
